//
//
//
//
//
//
//
//
//

import DetailCoin from '~/components/detail/mobile/detail_coin'
import ChartWeblog from '~/components/detail/mobile/chart_weblog'
import SuggestedCoins from '~/components/detail/mobile/suggested_coins'
import Tags from '~/components/detail/mobile/tags_mobile'

export default {
  name: 'Mobile',
  components: {
    DetailCoin,
    ChartWeblog,
    SuggestedCoins,
    Tags
  },
  props: {
    coin: {
      type: Object,
      default: null
    }
  }
}
